import React from 'react';
import contactUsBtnImg from '../assets/icons/contactus_btn_img.png'
import { styled } from '@mui/material';
import { useNavigate,useLocation } from 'react-router-dom';

export const ContactUsButton = styled("button")`
  position: fixed;
  right: 0;
  top: 40%;
  transform: translateY(-50%);
  background-color: #1D00C4;
  color: #FFF;
  font-family: Radikal;
  font-size:1.377rem;// 22.04px
  font-weight: 500;
  padding: 2vw 1vw;
  border: none;
  border-radius: 20px 0 0 20px; 
  cursor: pointer;
  writing-mode: vertical-rl; 
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000; 
  box-shadow: -2px 0px 5px rgba(0, 0, 0, 0.2);
  
  img {
    width: 2vw; 
    height: auto;
    margin-top: 0.9vw;
  }
  @media (max-width: 1280px) {
    font-size: 1rem; 
    padding: 1.5vw 1vw;
  }
  @media (max-width: 768px) {
    font-size: 1rem; 
    padding: 5vw 2vw 4vw 3vw; 
    top: 30%;
    img {
      width: 5vw; 
      margin-top:2.5vw; 
    }
  }
`;


const ContactUsButtonComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleNavigate = () => {
    window.scrollTo(0, 0); 
    navigate('/contact-us');
  };

  if (location.pathname === '/contact-us') {
    return null; 
  }
  return (
    <ContactUsButton onClick={handleNavigate}>
    Contact Us
    <img src={contactUsBtnImg} alt="Contact Us" />
  </ContactUsButton>
  );
};

export default ContactUsButtonComponent;
